import { Link } from "react-router-dom";
import { PageHero, Container, Overline } from "../components/Section";
import { Sparkles, ArrowRight } from "lucide-react";

const STEPS = [
  { n: 1, title: "Attend a Service", body: "Join us for Sunday worship, Bible Study, or any of our gatherings. Come as you are." },
  { n: 2, title: "Take New Members Class", body: "A multi-week orientation that covers what we believe, who we are, and how to plug in." },
  { n: 3, title: "Be Baptized", body: "If you've placed your trust in Christ, baptism is the public declaration of that decision." },
  { n: 4, title: "Find Your Place", body: "Join a Sunday School class, a small group, a ministry team. Belong, then serve." },
];

export default function NewMemberInfo() {
  return (
    <div data-testid="new-member-info-page">
      <PageHero
        overline="New Member Information"
        title={<>Welcome to <em className="text-gold-light italic font-light">the family</em>.</>}
        kicker="We're so glad you're here. Here's what to expect on your journey to membership at Sixth Mount Zion."
      />

      <Container className="pb-32">
        <Overline>Your Path</Overline>
        <h2 className="font-serif text-4xl md:text-5xl font-black mb-12">Four steps to membership.</h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 mb-20">
          {STEPS.map((s) => (
            <div key={s.n} className="bg-wine-950 p-10">
              <div className="font-serif italic text-6xl text-gold/40 mb-6">0{s.n}</div>
              <h3 className="font-serif text-xl font-bold mb-3">{s.title}</h3>
              <p className="text-white/65 text-sm leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>

        <div className="glass p-12 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <Sparkles className="h-6 w-6 text-gold mb-4" />
            <h3 className="font-serif text-3xl font-black mb-4">Ready to take the next step?</h3>
            <p className="text-white/70">Fill out our New Member form to get connected with our membership team. We'll reach out personally to welcome you.</p>
          </div>
          <div className="flex md:justify-end">
            <Link to="/members/forms" className="btn-wine px-8 py-4 rounded-full text-sm uppercase tracking-widest font-semibold inline-flex items-center gap-2" data-testid="new-member-form-cta">
              New Member Form <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </Container>
    </div>
  );
}
